import React, { useState, useEffect } from 'react'
import { CAlert, CButton } from '@coreui/react'
import AuthService from 'src/services/auth.service'

const AppUpdateBanner = () => {
  const [registration, setRegistration] = useState(null)

  useEffect(() => {
    // Check if there's already a waiting SW from a previous detection
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg?.waiting) {
          setRegistration(reg)
        }
      })
    }

    const handler = (e) => setRegistration(e.detail)
    window.addEventListener('swUpdated', handler)
    return () => window.removeEventListener('swUpdated', handler)
  }, [])

  if (!registration) return null

  const handleUpdate = () => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    window.location.reload()
  }

  const isLoggedIn = !!AuthService.getCurrentUser()

  // Usuario ya logueado: overlay bloqueante, no puede continuar sin actualizar
  if (isLoggedIn) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 99999,
          background: 'rgba(0,0,0,0.75)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            background: '#fff',
            padding: '2rem',
            borderRadius: '8px',
            textAlign: 'center',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
          }}
        >
          <h5 className="mb-2">Nueva versión disponible</h5>
          <p className="text-muted mb-3">Es necesario actualizar la aplicación para continuar.</p>
          <CButton color="primary" onClick={handleUpdate}>
            Actualizar ahora
          </CButton>
        </div>
      </div>
    )
  }

  // Usuario no logueado: banner informativo (Login forzará el update al ingresar)
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '8px',
      }}
    >
      <CAlert
        color="info"
        className="d-flex align-items-center justify-content-between mb-0 shadow"
      >
        <span>
          <strong>Nueva versión disponible.</strong> Se actualizará al ingresar.
        </span>
        <CButton size="sm" color="primary" onClick={handleUpdate} className="ms-3 flex-shrink-0">
          Actualizar ahora
        </CButton>
      </CAlert>
    </div>
  )
}

export default AppUpdateBanner
